import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { VisibilityActions } from '../actions/VisibilityActions';
import { VisibilityStore } from '../stores/VisibilityStore';

interface PriceInfoState {
    priceInfo?: boolean;
}

export class PriceInfo extends BaseComponent<{}, PriceInfoState> {
    constructor(props: {}) {
        super(props);
        this.close = this.close.bind(this);
    }

    public componentWillMount(): void {
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): React.ReactNode {
        if (!this.state.priceInfo) {
            return null;
        }

        return (
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    maxWidth: '70%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                    padding: '48px 20px 20px',
                    color: 'red',
                    background: '#FFFFFF',
                    boxShadow: '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
                }}
            >
                <div className="overlay-close-button" onClick={this.close}/>
                <pre style={{whiteSpace: 'pre-wrap'}}>
                    *** {t('Please note the currently valid material cost surcharge')} ***
                </pre>
            </div>
        );
    }

    protected onChange = (): void => {
        const { priceInfo } = VisibilityStore.getState();
        this.setState({
            priceInfo
        });
    };

    private close(): void {
        VisibilityActions.showPriceInfo(false);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PriceInfo.tsx